package com.essntl.features.organization.domain.repository

import com.essntl.features.organization.domain.model.OrganizationModel

interface OrganizationRepository {
    suspend fun getAll(
        page: Long,
        limit: Int = 10,
        query: String,
        type: OrganizationModel.Type? = null,
    ): Result<List<OrganizationModel>>

    suspend fun get(id: String): Result<OrganizationModel>

    suspend fun update(organization: OrganizationModel): Result<OrganizationModel>

    suspend fun getCountOrganizationsByLogo(logoId: String): Result<Long>
}